import React from "react";
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { useState, useEffect, useContext } from "react";

//Import Context
import {AppContext} from '../../App'

//Import FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleDown } from "@fortawesome/free-solid-svg-icons";

//Import Css
import './soluciones.css'

//Import Component
import MenuScrollBarComponent from "../menuScrollBarComponent/menuScrollBarComponent";
import {FooterComponent} from '../footerComponent/footerComponent';


//Import Assets
import bannerSolucionesParalax from '../../assets/solucionesAssets/PortadaSoluciones.jpg'
import Icon247 from '../../assets/solucionesAssets/icon-24-7.svg'
import photo247 from '../../assets/solucionesAssets/photo247.jpg'
import guardianiaVirtual from '../../assets/solucionesAssets/guardianiaVirtual.jpg'
import photoActivosVigilados from '../../assets/solucionesAssets/photoActivoVigilados.jpg'
import logoMonitronix from '../../assets/homeAssets/logo-monitronix.svg'
import IconAsTecnico from '../../assets/solucionesAssets/Icon-Asesoramiento-Tecnico.svg'
import IconInstGarantizada from '../../assets/solucionesAssets/Icon-Instalacion-Garantizada.svg'
import IconServTecnicoPro from '../../assets/solucionesAssets/Icon-Servicio-Tecnico.svg'
import IconMonitoreoAlerta from '../../assets/solucionesAssets/Icon-Monitoreo-Alerta.svg'
import photoSEmpresarial1 from '../../assets/solucionesAssets/PhotoSEmpresarial-1.jpg'
import photoSEmpresarial2 from '../../assets/solucionesAssets/PhotoSEmpresarial-2.jpg'
import photoSEmpresarial3 from '../../assets/solucionesAssets/PhotoSEmpresarial-3.jpg'


export default function Soluciones() {

    const {
 
    // Props Menu Bar Scroll Page
        linkUrl,
        nameClass,
        namePage
 
     } = useContext(AppContext); 

    // Background Portada Q somos 
    const isMobileSolucionesQSomos = window.innerWidth <= 620;
    const styleBkBannerSolucionesParalax = {
        backgroundImage: `url(${bannerSolucionesParalax})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: "fixed",
        width: '100%',
        height: isMobileSolucionesQSomos? '60vh' : '380px',

    }


    return(

        
        <div className="container-soluciones-component">

            {/* // Sección menú scroll bar */}
            <div className="container-menu-component">
    
                <MenuScrollBarComponent 
                
                    linkUrl1={linkUrl[0]}
                    linkUrl2={linkUrl[1]}
                    linkUrl3={linkUrl[3]}
                    linkUrl4={linkUrl[4]}
        

                    nameClass1={nameClass[0]}
                    nameClass2={nameClass[1]}
                    nameClass3={nameClass[3]}
                    nameClass4={nameClass[4]}
                    

                    namePage1={namePage[0]}
                    namePage2={namePage[1]}
                    namePage3={namePage[3]}
                    namePage4={namePage[4]}
                
                />

    
            </div>


            {/* // SECCIÓN BANNER SOLUCIONES */}
            <div className="banner-top-soluciones" style={styleBkBannerSolucionesParalax}>

                <div className="box-text-soluciones">
                    <h2 className="title-soluciones">SOLUCIONES</h2>
                    <p className="text-slogan-soluciones">TECNOLOGICAS EN SEGURIDAD ELECTRÓNICA</p>
                </div>

                <div className="box-logo-banner-monitronix-soluciones">
                    <img className="logo-banner-monitronix-soluciones" src={logoMonitronix}/>
                </div>

            </div>


            {/* // SECCIÓN EMPRESA */}
            <div className="container-info-v-monitoreo">

                <h2 className="title-v-monitoreo">VIGILANCIA Y MONITOREO</h2>
                <p className="text-info-v-monitoreo">
                    Ofremos a nuestros clíentes soluciones integrales en seguridad electronica con 
                    monitoreo y vigilancia activa 24/7 para hogares, negocios, empresas y vehículos.
                    Ofrecemos tecnología de punta en cada proyecto con mano de obra calificada y 
                    sistemas certificados que garantía su seguridad.</p>

            </div>


            {/* // SECCIÓN 24-7 */}
            <div className="container-24-7-soluciones">

                <div className="box-photo-24-7-soluciones" >
                    <img className="photo-24-7-soluciones" src={guardianiaVirtual}/>
                </div>

                <div className="box-text-24-7-soluciones alt-gVirtual">

                    <div className="box-info-all-24-7">

                        <h2 className="title-24-7-soluciones">GUARDIANÍA VIRTUAL CON <span className="tag-text-celeste">ASISTENCIA REMOTA 24/7</span></h2>

                        <div className="box-24-7-text">
                            <p className="text-24-7">
                                Contamos con un sistema de monitoreo avanzado que nos permite dar seguimiento y asistencia a 
                                cualquier evento o alerta en tiempo real.</p>

                        </div>

                        <p className="text-24-7-soluciones">
                            Contamos con tecnología de punta que nos permite brindarle guardianía virtual y asistencia remota las 24 horas
                            del día con notificaciones sobre alertas o eventos directos a su teléfono movil por medio de whatsapp. 
                            Atendemos de manera inmedita alertas de emergencia como robos, incendios, cierres o aperturas de negocios,
                            activación de alarmas entre otros. 
                            Ahorre en costo excesivos de vigilancia física sin sacrificar seguridad y cobertura.
                        </p>

                    </div>

                </div>

            </div>


            {/* // SECCIÓN 24-7 */}
            <div className="container-24-7-soluciones">

                <div className="box-text-24-7-soluciones">

                    <div className="box-info-all-24-7">

                        <h2 className="title-24-7-soluciones">TU HOGAR SEGURO Y <span className="tag-text-celeste">MONITORIZADO</span></h2>

                        <div className="box-24-7-text">
                            <img className="icon-24-7" src={Icon247}/>
                            <p className="text-24-7">
                                Ofremos a nuestros clientes multiples soluciones de 
                                seguridad para el hogar.</p>

                        </div>

                        <p className="text-24-7-soluciones">
                            Somos una compañía orientada a satisfacer las más exigentes 
                            necesidades de seguridad electrónica para brindar soluciones 
                            integrales y eficientes  que resguarden a su familia, bienes 
                            y negocios con eficiencia, calidad y garantía.
                        </p>

                    </div>

                </div>

                <div className="box-photo-24-7-soluciones" >
                    <img className="photo-24-7-soluciones" src={photo247}/>
                </div>

            </div>


            {/* // SECCIÓN ACTIVOS VIGILADOS */}
            <div className="container-activos-vigilados">

                <div className="box-photo-activos-vigilados">

                    <img className="photo-activos-vigilados" src={photoActivosVigilados}/>

                </div>

                <div className="box-text-activos-vigilados">

                    <h2 className="title-activos-vigilados">TUS ACTIVOS<br></br> SIEMPRE <span className="tag-text-celeste">VIGILADOS</span></h2>

                    <p className="text-a-vigilados text-av-1">
                        Monitronix SAS ofrece una amplia gama de 
                        soluciones comerciales para multiples 
                        necesidades de vídeo vigilancia y monitoreo.</p>

                    <p className="text-a-vigilados text-av-2">
                        Controla de forma remota y desde tu celular las 
                        operaciones de tu negocio mediante equipos con 
                        tecnología wifi certificados.
                    </p>

                    <h2 className="title-activos-vigilados sub-title-activos-vigilados">VIGILANCIA PERMANENTE</h2>

                    <p className="text-a-vigilados text-av-3">
                        Ofrecemos a nuestros clientes monitoreo permanente 
                        desde nuestra sala de vigilancia remota con personal 
                        siempre atento al momento de una alerta.
                    </p>

                </div>
            

            </div>


            {/* BANNER ASESORAMIENTO */}
            <div className="container-banner-asesoramiento">

                    <h2 className="title-banner-asesoramiento">SERVICIO Y ASESORAMIENTO<br/> INTEGRAL</h2>
                    <p className="slogan-asesoramiento">¡Monitronix SAS es respaldo en cada paso!</p>
                
                    <div className="box-icon-asesoramiento">

                        <div className="box-icon-text-as box-icon-text-1">
                            <img className="icon-figure icon-AsTecnico" src={IconAsTecnico} alt="Asesoramiento Técnico" />
                            <p className="text-name-as text-AsTecnico">Asesoramiento <br/> Técnico</p>
                        </div>

                        <div className="box-icon-text-as box-icon-text-1">
                            <img className="icon-figure icon-InstGarantizada" src={IconInstGarantizada} alt="Asesoramiento Técnico" />
                            <p className="text-name-as text-InstGarantizada">Instalación <br/> Garantizada</p>

                        </div>

                        <div className="box-icon-text-as box-icon-text-1">
                            <img className="icon-figure icon-ServTecnicoPro" src={IconServTecnicoPro} alt="Asesoramiento Técnico" />
                            <p className="text-name-as text-ServTecnicoPro">Servicio Técnico Profesional</p>

                        </div>

                        <div className="box-icon-text-as box-icon-text-1">
                            <img className="icon-figure icon-MonitoreoAlerta" src={IconMonitoreoAlerta} alt="Asesoramiento Técnico" />
                            <p className="text-name-as text-MonitoreoAlerta">Monitoreo<br/> y Alerta 24/7</p>

                        </div>

                    </div>
            </div> 

             {/* SECCIÓN SOLUCIONES EMPRESARIALES */}
            <div className="container-s-empresariales">

                <h2 className="title-s-empresariales">SOLUCIONES ENPRESARIALES</h2>
                <p className="text-slogan-s-empresarial">Contamos con la solución que tu empresa y comunidad necesitan</p>

                    <div className="box-photo-s-empresarial">

                        <div className="box-photo-text-emp">
                            <img className="photo-s-empresarial" src={photoSEmpresarial1} />
                            <div className="cuadro-texto-vc v-comunitaria">
                                <p className="text-descrip-se text-descrip-v-comunitaria">Vigilancia Comunitaria</p>
                            </div>
                        </div>

                        <div className="box-photo-text-emp">
                            <img className="photo-s-empresarial" src={photoSEmpresarial2} />
                            <div className="cuadro-texto-vc v-comunitaria">
                                <p className="text-descrip-se text-descrip-v-espacios">Vigilancia en Espacios Comerciales</p>
                            </div>
                        </div>

                        <div className="box-photo-text-emp">
                            <img className="photo-s-empresarial" src={photoSEmpresarial3} />
                            <div className="cuadro-texto-vc v-comunitaria">
                                <p className="text-descrip-se text-descrip-v-parqueaderos">Vigilancia en Parqueaderos</p>
                            </div>
                        </div>

                    </div>

            </div>




            {/* SECCIÓN ASESORAMIENTO */}
            <div className="box-text-asesoramiento"> 
                <p className="text-asesoramiento-tech">Solicita asesoramiento personalizado sin costo.</p>
                <p className="text-contactanos">CONTÁCTANOS</p>
                <span><FontAwesomeIcon icon={faAngleDown} /></span>  

            </div>

            {/* SECCIÓN FOOTER COMPONENTS */}
            <FooterComponent />


        </div>

    );

}